import React from "react";
import ReactPhoneNumber, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./style.css";
// import CountrySelectNative from "../../SimpleForm/BaseInputs/PhoneInput/PhoneInputCountrySelect";

function PhoneNumberInput(props) {
  const [value, setValue] = React.useState(null);

  const {
    input,
    meta: { touched },
  } = props;
  let applyValueFormat =
    input.value.length === 0 || input.value.indexOf("+") > -1
      ? input.value
      : `+${input.value}`;

  return (
    <>
      <label className="" htmlFor="extension">
        Phone Number *
      </label>
      <ReactPhoneNumber
        {...input}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault(); // this code prevents other buttons triggers use this
          }
        }}
        onChange={(val) => {
          setValue(val);
        }}
        onBlur={(e) => {
          input.onChange(value);
        }}
        value={applyValueFormat}
        defaultCountry="US"
      />

      {touched && !isValidPhoneNumber(value) && (
        <span
          className="usa-error-message"
          id="input-error-message"
          role="alert"
        >
          {"Invalid phone number"}
        </span>
      )}
    </>
  );
}

export default PhoneNumberInput;
